/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import { REQUIRED_ONBOARDING } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
export const ENDPOINT = '/eligibility-engine/v4/onboarding';
export const getRequiredOnboarding = () => {
  const earlyRequest = getEarlyRequesterResult(REQUIRED_ONBOARDING);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.post(ENDPOINT, {
    data: {}
  })) : null;
  return earlyRequestWithRetry || http.post(ENDPOINT, {
    data: {}
  });
};
export const getRequiredOnboardingWithMRRCheck = productConfigurations => {
  return http.post(ENDPOINT, {
    data: {
      productConfigurations
    }
  });
};